import { useEffect } from 'react'

const BASE_TITLE = 'Hewey'

/**
 * Set the document title in the head tag
 */
const useDocTitle = (title = BASE_TITLE, includeBaseTitle = false) => {
	useEffect(() => {
		document.title =
			title !== BASE_TITLE && includeBaseTitle
				? `${title} | ${BASE_TITLE}`
				: title
	}, [title, includeBaseTitle])
}

export default useDocTitle
